import { gql } from 'apollo-angular';
import { Page } from '../../entities/page/page';
import { ConnectedDevice } from '../../entities/connected-device/connected-device';

export const MOBILE_DEVICES_QUERY = gql`
query mobileDevicesQuery(
  $pageNumber: Int,
  $pageSize: Int,
  $sortProperty: String,
  $sortDirection: String,
  $text: String,
  $type: ConnectedDeviceType)
{
  mobileDevices: getConnectedDevicesPaged(
    filter: {
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection},
      type: $type,
      text: $text
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
        id
        appVersion
        lastSeenDateTime
        platform
        model
        name
        user{
          id
          firstName
          lastName
        }
        permissions
        androidSdk
        createdDateTime
        updateState
      }
  }
}
`;

export interface MobileDevicesQueryResponse {
  mobileDevices: Page<ConnectedDevice>;
  loading: boolean;
}
